import {
  IonContent,
  IonPage,
  IonSearchbar,
  IonButton,
  IonIcon,
} from '@ionic/react';
import { download } from 'ionicons/icons';
import React, { useState } from 'react';

import Header from '../components/Header';
import Loader from '../components/Loader';

import IResult from '../models/Models';

import FadeIn from 'react-fade-in';

const HomePage: React.FC = () => {
  const [search, setSearch] = useState<string>('');
  const [hasErrors, setErrors] = useState<boolean>(false);
  const [hasNoResults, setNoResults] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [searchResults, setSearchResults] = useState<Array<IResult>>([]);

  const onSearch = (event: any) => {
    setSearch(event.target.value)
  }

  const onKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      console.log('enter pressed')
      onPricelistLookup()
    }
  }

  const onPricelistLookup = () => {
    setErrors(false);
    setNoResults(false);

    if (search.length > 1) {
      setLoading(true);

      const data = {
        search,
      };

      fetch(`https://materialised.com.au/wp-json/pricelist/v1/search`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.length) {
            // console.log(res)
            setSearchResults(res);
          } else {
            setSearchResults([]);
            setNoResults(true);
          }
        })
        .catch(() => setErrors(true))
        .finally(() => setLoading(false));
    } else {
      setSearchResults([]);
    }
  };

  const results =
    searchResults && !hasNoResults ? (
      <ul className="list-unstyled text-center mb1">
        {searchResults.map((pricelist, index) => (
          <FadeIn key={pricelist.id}>
            <li>
              <IonButton color="primary" href={pricelist.url} target="_blank">
                <IonIcon slot="start" icon={download} />
                {pricelist.label ? pricelist.label : 'Download PDF'}
              </IonButton>
            </li>
          </FadeIn>
        ))}
      </ul>
    ) : (
      <FadeIn>
        <div className="has-errors position-absolute">
          <div className="speech-bubble">
            Nothing found, try a different code?
          </div>
        </div>
      </FadeIn>
    );

  return (
    <IonPage>
      <IonContent>
        <div className="container text-center mw-500 px1">
          <Header />

          <p>
            <a
              className="is-text-only"
              rel="noopener noreferrer"
              target="_blank"
              href="https://materialised.com.au/resources/price-lists/"
            >
              All existing clients please contact us for a unique login code to
              access your price list. New trade customers can apply for a code
              here.
            </a>
          </p>
          <p>Please enter your code and click the button to access your price list.</p>

          <div className="position-relative">
            <div className="search-wrapper">
              <IonSearchbar
                onIonChange={onSearch}
                // debounce={500}
                inputMode="text"
                placeholder="i.e. AU20"
                searchIcon=""
                onKeyPress={onKeyPress}
              ></IonSearchbar>
              <IonButton
                onClick={onPricelistLookup}
              >Check Code</IonButton>
            </div>
            {hasErrors && (
              <FadeIn>
                <div className="has-errors position-absolute">
                  <div className="speech-bubble">
                    Ooops that code is incorrect
                  </div>
                </div>
              </FadeIn>
            )}
            {isLoading && <Loader />}

            {!isLoading && results}

            <p className='tint'> When you download the price lists, please DO NOT save to desktop.
              By referring to the lists through this page, you can always be certain of accessing current pricing.</p>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default HomePage;